import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";

const FreeText = (props) => {
    const {
        question,
        containerClassName = "free-text-container",
        maxLength = 200,
        onChange,
        value = "",
        multiline = true,
        ...rest
    } = props;

    return (
        <div className={containerClassName}>
            <span className={"question"}>{question.q}</span>
            <div className="deterministic-outlined-input">
                <TextField
                    label=""
                    variant="outlined"
                    id="deterministic-outlined-input"
                    multiline={multiline}
                    rows={8}
                    placeholder="Type anything you would like us to know"
                    autoFocus
                    fullWidth
                    inputProps={{ maxLength }}
                    onChange={onChange}
                    helperText={`${value.length}/${maxLength}`}
                    {...rest}
                />
            </div>
        </div>
    );
};

FreeText.propTypes = {
    question: PropTypes.shape({
        answers: PropTypes.arrayOf(PropTypes.string),
        other: PropTypes.bool,
        q: PropTypes.string,
    }),
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
    value: PropTypes.string,
    containerClassName: PropTypes.string,
    multiline: PropTypes.bool,
};

export default FreeText;
